import config from "../../components/megawidget/widget-config";
import Vendor from "../../models/enums/vendor-enum";
import DictionaryType from "../../models/enums/dictionary-type-enum";
import DictionaryAll from "../../models/dictionary-all";
import ApiFacade from "../api-facade";
import Result from "../../models/result";
import SubResult from "../../models/subresult";
import { IWidgetState } from "../../components/megawidget/megawidget-specialty/common/common-reducer";
import React from "react";
import { IAction } from "../../components/megawidget/megawidget-specialty/common/common-actions";
import ActionType from "../../models/enums/action-type";
import WidgetSizeHelper from "../../helpers/widget-size-helper";
import damianLogo from "./../../images/damian-logo.svg";
import rehasportLogo from "./../../images/rehasport-logo.jpg";
import AppointmentHelper from "../../helpers/appointment-helper";
import DateHelper from "../../helpers/date-helper";
import { GetRequest } from "../../components/megawidget/megawidget-specialty/common/common";
import AppointmentsAggregate from "../../models/appointmentsAggregate";
import { useParams } from "react-router";

class MegawidgetCommonFacade {
  private state: IWidgetState;
  private dispatch: React.Dispatch<IAction>;
  static megawidgetCommonFacade: MegawidgetCommonFacade;


  constructor(state: IWidgetState, dispatch: React.Dispatch<IAction>) {
    this.state = state;
    this.dispatch = dispatch;
    MegawidgetCommonFacade.megawidgetCommonFacade = this;
  }

  async getDoctors() {
    let doctors = [];
    await ApiFacade.post(
      `${config.API_URL}/api/v2/Doctor/Doctors`,
      {},
      null
    ).then((data) => {
      doctors = data.items;
    });
    this.dispatch({
      type: ActionType.setDoctors,
      payload: { doctors: doctors },
    });
  }

  async getRedirectionLink(clinicCode: string, specialityCode: string, regionCode: string, doctorCode: string, vendorCode: string, appointmentDate: Date): Promise<any> {
    const body = {
     "vendorCode": vendorCode,
     "clinicCode": clinicCode,
     "regionCode": regionCode,
     "specialtyCode": specialityCode,
     "doctorCode": doctorCode,
     "appointmentDate": new Date(appointmentDate.toUTCString()),
     "telemedicine": this.state.isTelemedicineAvailable
   }
   const redicrectionUrl = ApiFacade.post(`${config.API_URL}/api/v2/Slot/RedirectionLink`, body, null);
   return redicrectionUrl;
 }

  async getAvailableSlots(doctorCode: string, vendorCode: string): Promise<any> {
    const today = new Date();
    const dateTo = new Date();
    dateTo.setDate(today.getDate() + 30);
    const vendorCodeToBackend = vendorCode === "CMD-MH" || vendorCode === "CMD-Damian" ? 'CMD' : vendorCode;
    const body = {
      "slotInterval": {
        "dateFrom": today,
        "dateTo": dateTo
      },
      "appointmentStartDate": today,
      "daysToFetch": 30,
      "isValidDayWithSlots": true,
      "maxFutureSearchingDays": 100,
      "doctorCode": doctorCode,
      "vendorCode": vendorCodeToBackend
    }

    this.setIsLoading(true);
    var specializationGroups;
    await ApiFacade.post(`${config.API_URL}/api/v2/Slot/DoctorSlots`, body, null)
    .then(data => {
      this.setIsLoading(false);
      specializationGroups = data.items;
    })

    if (vendorCode === "CMD-MH" ) {
        specializationGroups.forEach(x => x.clinics = x.clinics.filter(x => x.isMindHealth));
        specializationGroups = specializationGroups.filter(x => x.clinics.length > 0);
    } else if (vendorCode === "CMD-Damian") {
        specializationGroups.forEach(x => x.clinics = x.clinics.filter(x => !x.isMindHealth));
        specializationGroups = specializationGroups.filter(x => x.clinics.length > 0);
    }

    if (specializationGroups != null && specializationGroups.length > 0) {
     // const doctors = [appointmentSlots.items[0].doctor];
      var specialities = [];
      specializationGroups.forEach(element => {
        if (element.telemedicine == false) {
          specialities.push({ additionalDesc: element.additionalDesc, code: element.code, description: element.description, telemedicine: element.telemedicine  });
        }
      });

      var groupsToDisplay = specializationGroups.filter(x => !x.telemedicine);
      var isTelemedicineAvailable = specializationGroups.filter(x => x.telemedicine).length > 0;
      var isOfficeAvailable = false;
      if (groupsToDisplay.length === 0 && isTelemedicineAvailable) {
        groupsToDisplay = specializationGroups;
        this.dispatch({ type: "SET_SERVICE_IN_OFFICE", payload: { serviceInOffice: false } });
        isOfficeAvailable = true;
      }
      groupsToDisplay = groupsToDisplay.sort((a,b) => a.additionalDesc.localeCompare(b.additionalDesc));
      this.dispatch({
        type: ActionType.setIsTelemedicineAvailable,
        payload: { isTelemedicineAvailable: isTelemedicineAvailable },
      })
      this.dispatch({
        type: ActionType.setIsOfficeAvailable,
        payload: { isOfficeAvailable: isOfficeAvailable },
      })
      this.dispatch({
        type: ActionType.setAggregatedDataToDisplay,
        payload: { aggregatedData: groupsToDisplay },
      })
      this.dispatch({
        type: ActionType.setSpecialities,
        payload: { specialities: specialities },
      });
      this.dispatch({
        type: ActionType.setClinics,
        payload: { clinics: groupsToDisplay[0].clinics },
      });
      this.dispatch({
        type: ActionType.setAggregatedData,
        payload: { aggregatedData: specializationGroups },
      });
      this.dispatch({
        type: ActionType.setAvailableDays,
        payload: { availableDays: groupsToDisplay[0].clinics[0].days },
      });
      this.dispatch({
        type: ActionType.setSelectedDate,
        payload: { selectedDate: new Date(groupsToDisplay[0].clinics[0].days[0].date) },
      });
      this.dispatch({
        type: ActionType.setClinicCode,
        payload: { selectedClinicCode: groupsToDisplay[0].clinics[0].code },
      });

      this.dispatch({
        type: ActionType.setClinicDescription,
        payload: { selectedClinicDescription: groupsToDisplay[0].clinics[0].description },
      });

      this.dispatch({
        type: ActionType.setRegionCode,
        payload: { selectedRegionCode: groupsToDisplay[0].clinics[0].regionCode },
      });

      this.dispatch({
        type: ActionType.setSpecialisationCode,
        payload: { selectedSpecialisationCode: groupsToDisplay[0].code },
      });

      this.dispatch({
        type: ActionType.setSpecialisationDescription,
        payload: { selectedSpecialisationDescription: groupsToDisplay[0].additionalDesc },
      });
      
    } else if (specializationGroups != null && specializationGroups.length === 0) {
      this.dispatch({
        type: ActionType.setSlotsNotAvailable,
        payload: { slotsNotAvailable: true },
      });
    }
  }

  async getAppointments(url: string): Promise<any> {
    const newResult = new Result();
    await ApiFacade.get(url, null).then((obj) => {
      if (obj && obj.dailyAppointmentsList) {
        for (let dailyList of obj.dailyAppointmentsList) {
          const subRes = new SubResult();
          subRes.appointmentsDate = new Date(dailyList.appointmentsDate);
          subRes.appointmentsCounter = dailyList.appointmentsCounter;
          subRes.appointments = dailyList.appointments;
          newResult.subResults.push(subRes);
        }
      }
    });
    return newResult;
  }

  async setDictionaries() {
    const allDicts = new DictionaryAll();

    for (let element of Object.values(DictionaryType)) {
      if (isNaN(Number(element))) {
        await ApiFacade.get(
          `${config.API_URL}/api/dictionary?dictionarytype=${DictionaryType[element]}&vendor=${Vendor.Medicover}`,
          null
        ).then((data) => {
          if (data && data.dictionaryItems) {
            allDicts[element] = data.dictionaryItems;
          }
        });
      }
    }
    this.dispatch({
      type: ActionType.setDicts,
      payload: { allDicts: allDicts },
    });
  }

  setInitialSize() {
    const parameters = window.location.pathname.split(/[/ ]+/);
    const size = parameters[1].toUpperCase();

    this.dispatch({
      type: WidgetSizeHelper[size].stateActions.setPresentedDateIndex,
      payload: {
        stopPresentedDateIndex: WidgetSizeHelper[size].presentedDates,
      },
    });
    this.dispatch({
      type: WidgetSizeHelper[size].stateActions.setWidgetSize,
      payload: { widgetSize: WidgetSizeHelper[size].displayName },
    });
  }

  setInitialVendor() {
    const url = window.location.href;
    const vendor = url.slice(url.indexOf('vendor:') + 'vendor:'.length, url.indexOf('doctorCode:') - 1);
    let doctorCode = '';
    let color = '';
    if (url.indexOf('color') > 0) {
       doctorCode = url.slice(url.indexOf('doctorCode:') + 'doctorCode:'.length, url.indexOf('color:') - 1);
       color = url.slice(url.indexOf('color:') + 'color:'.length);
    } else {
      doctorCode = url.slice(url.indexOf('doctorCode:') + 'doctorCode:'.length);  
    }
    switch (vendor) {
      case "CMD-Damian":
        document.documentElement.style.setProperty(
          "--s-topElementTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--s-switchBarTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementActiveBackgroundColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementBorderColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementInActiveTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementActiveTextColor",
          "#fff"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementInactiveBackgroundColorHover",
          "#ddd"
        );
        document.documentElement.style.setProperty(
          "--s-singleResultHourTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--s-singleResultServicePriceTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--s-dateChoiceArrowColorHover",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--s-showAllResultsButtonBackgroundColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--s-showAllResultsButtonBackgroundColorHover",
          "#22885B"
        );
        document.documentElement.style.setProperty(
          "--s-topLogoSmallIcon",
          `url(${damianLogo})`
        );

        document.documentElement.style.setProperty(
          "--m-topElementTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--m-switchBarTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementActiveBackgroundColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementBorderColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementInActiveTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementActiveTextColor",
          "#fff"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementInactiveBackgroundColorHover",
          "#ddd"
        );
        document.documentElement.style.setProperty(
          "--m-singleResultHourTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--m-singleResultServicePriceTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--m-dateChoiceArrowColorHover",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--m-showAllResultsButtonBackgroundColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--m-showAllResultsButtonBackgroundColorHover",
          "#22885B"
        );
        document.documentElement.style.setProperty(
          "--m-topLogoSmallIcon",
          `url(${damianLogo})`
        );

        document.documentElement.style.setProperty(
          "--l-topElementTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--l-switchBarTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementActiveBackgroundColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementBorderColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementInActiveTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementActiveTextColor",
          "#fff"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementInactiveBackgroundColorHover",
          "#ddd"
        );
        document.documentElement.style.setProperty(
          "--l-singleResultHourTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--l-singleResultServicePriceTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--l-dateChoiceArrowColorHover",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--l-showAllResultsButtonBackgroundColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--l-showAllResultsButtonBackgroundColorHover",
          "#22885B"
        );
        document.documentElement.style.setProperty(
          "--l-topLogoSmallIcon",
          `url(${damianLogo})`
        );

        document.documentElement.style.setProperty(
          "--xl-topElementTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--xl-switchBarTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementActiveBackgroundColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementBorderColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementInActiveTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementActiveTextColor",
          "#fff"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementInactiveBackgroundColorHover",
          "#ddd"
        );
        document.documentElement.style.setProperty(
          "--xl-singleResultHourTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--xl-singleResultServicePriceTextColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--xl-dateChoiceArrowColorHover",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--xl-showAllResultsButtonBackgroundColor",
          color != '' ? color : "#006639"
        );
        document.documentElement.style.setProperty(
          "--xl-showAllResultsButtonBackgroundColorHover",
          "#22885B"
        );
        document.documentElement.style.setProperty(
          "--xl-topLogoSmallIcon",
          `url(${damianLogo})`
        );
        break;
        case "CMD-MH":
          document.documentElement.style.setProperty(
            "--m-slider",
            "#ffbc58"
          );
          document.documentElement.style.setProperty(
            "--s-topElementTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--s-switchBarTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--s-dateElementActiveBackgroundColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--s-dateElementBorderColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--s-dateElementInActiveTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--s-dateElementActiveTextColor",
            "#fff"
          );
          document.documentElement.style.setProperty(
            "--s-dateElementInactiveBackgroundColorHover",
            "#ddd"
          );
          document.documentElement.style.setProperty(
            "--s-singleResultHourTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--s-singleResultServicePriceTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--s-dateChoiceArrowColorHover",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--s-showAllResultsButtonBackgroundColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--s-showAllResultsButtonBackgroundColorHover",
            "#22885B"
          );
          document.documentElement.style.setProperty(
            "--s-topLogoSmallIcon",
            `url(${damianLogo})`
          );
  
          document.documentElement.style.setProperty(
            "--m-topElementTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--m-switchBarTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--m-dateElementActiveBackgroundColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--m-dateElementBorderColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--m-dateElementInActiveTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--m-dateElementActiveTextColor",
            "#fff"
          );
          document.documentElement.style.setProperty(
            "--m-dateElementInactiveBackgroundColorHover",
            "#ddd"
          );
          document.documentElement.style.setProperty(
            "--m-singleResultHourTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--m-singleResultServicePriceTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--m-dateChoiceArrowColorHover",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--m-showAllResultsButtonBackgroundColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--m-showAllResultsButtonBackgroundColorHover",
            "#22885B"
          );
          document.documentElement.style.setProperty(
            "--m-topLogoSmallIcon",
            `url(${damianLogo})`
          );
  
          document.documentElement.style.setProperty(
            "--l-topElementTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--l-switchBarTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--l-dateElementActiveBackgroundColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--l-dateElementBorderColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--l-dateElementInActiveTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--l-dateElementActiveTextColor",
            "#fff"
          );
          document.documentElement.style.setProperty(
            "--l-dateElementInactiveBackgroundColorHover",
            "#ddd"
          );
          document.documentElement.style.setProperty(
            "--l-singleResultHourTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--l-singleResultServicePriceTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--l-dateChoiceArrowColorHover",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--l-showAllResultsButtonBackgroundColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--l-showAllResultsButtonBackgroundColorHover",
            "#22885B"
          );
          document.documentElement.style.setProperty(
            "--l-topLogoSmallIcon",
            `url(${damianLogo})`
          );
  
          document.documentElement.style.setProperty(
            "--xl-topElementTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--xl-switchBarTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--xl-dateElementActiveBackgroundColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--xl-dateElementBorderColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--xl-dateElementInActiveTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--xl-dateElementActiveTextColor",
            "#fff"
          );
          document.documentElement.style.setProperty(
            "--xl-dateElementInactiveBackgroundColorHover",
            "#ddd"
          );
          document.documentElement.style.setProperty(
            "--xl-singleResultHourTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--xl-singleResultServicePriceTextColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--xl-dateChoiceArrowColorHover",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--xl-showAllResultsButtonBackgroundColor",
            color != '' ? color : "#3f6383"
          );
          document.documentElement.style.setProperty(
            "--xl-showAllResultsButtonBackgroundColorHover",
            "#22885B"
          );
          document.documentElement.style.setProperty(
            "--xl-topLogoSmallIcon",
            `url(${damianLogo})`
          );
          break;
  
      case "Rehasport":
        document.documentElement.style.setProperty(
          "--m-slider",
          "#ffbc58"
        );
        document.documentElement.style.setProperty(
          "--s-topElementTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--s-switchBarTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementActiveBackgroundColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementBorderColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementInActiveTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementActiveTextColor",
          "#fff"
        );
        document.documentElement.style.setProperty(
          "--s-dateElementInactiveBackgroundColorHover",
          "#ddd"
        );
        document.documentElement.style.setProperty(
          "--s-singleResultHourTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--s-singleResultServicePriceTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--s-dateChoiceArrowColorHover",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--s-showAllResultsButtonBackgroundColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--s-showAllResultsButtonBackgroundColorHover",
          "#84E4F2"
        );
        document.documentElement.style.setProperty(
          "--s-topLogoSmallIcon",
          `url(${rehasportLogo})`
        );

        document.documentElement.style.setProperty(
          "--m-topElementTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--m-switchBarTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementActiveBackgroundColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementBorderColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementInActiveTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementActiveTextColor",
          "#fff"
        );
        document.documentElement.style.setProperty(
          "--m-dateElementInactiveBackgroundColorHover",
          "#ddd"
        );
        document.documentElement.style.setProperty(
          "--m-singleResultHourTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--m-singleResultServicePriceTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--m-dateChoiceArrowColorHover",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--m-showAllResultsButtonBackgroundColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--m-showAllResultsButtonBackgroundColorHover",
          "#84E4F2"
        );
        document.documentElement.style.setProperty(
          "--m-topLogoSmallIcon",
          `url(${rehasportLogo})`
        );

        document.documentElement.style.setProperty(
          "--l-topElementTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--l-switchBarTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementActiveBackgroundColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementBorderColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementInActiveTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementActiveTextColor",
          "#fff"
        );
        document.documentElement.style.setProperty(
          "--l-dateElementInactiveBackgroundColorHover",
          "#ddd"
        );
        document.documentElement.style.setProperty(
          "--l-singleResultHourTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--l-singleResultServicePriceTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--l-dateChoiceArrowColorHover",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--l-showAllResultsButtonBackgroundColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--l-showAllResultsButtonBackgroundColorHover",
          "#84E4F2"
        );
        document.documentElement.style.setProperty(
          "--l-topLogoSmallIcon",
          `url(${rehasportLogo})`
        );

        document.documentElement.style.setProperty(
          "--xl-topElementTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--xl-switchBarTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementActiveBackgroundColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementBorderColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementInActiveTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementActiveTextColor",
          "#fff"
        );
        document.documentElement.style.setProperty(
          "--xl-dateElementInactiveBackgroundColorHover",
          "#ddd"
        );
        document.documentElement.style.setProperty(
          "--xl-singleResultHourTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--xl-singleResultServicePriceTextColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--xl-dateChoiceArrowColorHover",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--xl-showAllResultsButtonBackgroundColor",
          color != '' ? color : "#62C2D0"
        );
        document.documentElement.style.setProperty(
          "--xl-showAllResultsButtonBackgroundColorHover",
          "#84E4F2"
        );
        document.documentElement.style.setProperty(
          "--xl-topLogoSmallIcon",
          `url(${rehasportLogo})`
        );
        break;
        default: { 
          if (color != '') {
            document.documentElement.style.setProperty(
              "--s-topElementTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--s-switchBarTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--s-dateElementActiveBackgroundColor",
              color
            );
            document.documentElement.style.setProperty(
              "--s-dateElementBorderColor",
              color
            );
            document.documentElement.style.setProperty(
              "--s-dateElementInActiveTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--s-singleResultHourTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--s-singleResultServicePriceTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--s-dateChoiceArrowColorHover",
              color
            );
            document.documentElement.style.setProperty(
              "--s-showAllResultsButtonBackgroundColor",
              color
            ); 
            document.documentElement.style.setProperty(
              "--m-topElementTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--m-switchBarTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--m-dateElementActiveBackgroundColor",
              color
            );
            document.documentElement.style.setProperty(
              "--m-dateElementBorderColor",
              color
            );
            document.documentElement.style.setProperty(
              "--m-dateElementInActiveTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--m-singleResultHourTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--m-singleResultServicePriceTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--m-dateChoiceArrowColorHover",
              color
            );
            document.documentElement.style.setProperty(
              "--m-showAllResultsButtonBackgroundColor",
              color
            );
            document.documentElement.style.setProperty(
              "--l-topElementTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--l-switchBarTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--l-dateElementActiveBackgroundColor",
              color
            );
            document.documentElement.style.setProperty(
              "--l-dateElementBorderColor",
              color
            );
            document.documentElement.style.setProperty(
              "--l-dateElementInActiveTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--l-singleResultHourTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--l-singleResultServicePriceTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--l-dateChoiceArrowColorHover",
              color
            );
            document.documentElement.style.setProperty(
              "--l-showAllResultsButtonBackgroundColor",
              color
            );
            document.documentElement.style.setProperty(
              "--xl-topElementTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--xl-switchBarTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--xl-dateElementActiveBackgroundColor",
              color
            );
            document.documentElement.style.setProperty(
              "--xl-dateElementBorderColor",
              color
            );
            document.documentElement.style.setProperty(
              "--xl-dateElementInActiveTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--xl-singleResultHourTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--xl-singleResultServicePriceTextColor",
              color
            );
            document.documentElement.style.setProperty(
              "--xl-dateChoiceArrowColorHover",
              color
            );
            document.documentElement.style.setProperty(
              "--xl-showAllResultsButtonBackgroundColor",
              color
            );
          }
          break; 
       } 
    }
  }

  setNewSize(width: number) {
    if (this.state.widgetSize === WidgetSizeHelper.AUTOMATIC.displayName) {
      for (let el of Object.keys(WidgetSizeHelper)) {
        if (
          width >= WidgetSizeHelper[el].minWidth &&
          width < WidgetSizeHelper[el].maxWidth
        ) {
          const presentedDates = AppointmentHelper.getPresentedDates(
            this.state.result,
            0,
            WidgetSizeHelper[el].presentedDates
          );
          this.dispatch({
            type: ActionType.setStopPresentedDateIndex,
            payload: {
              stopPresentedDateIndex: WidgetSizeHelper[el].presentedDates,
            },
          });
          this.dispatch({
            type: ActionType.setPresentedDates,
            payload: { presentedDates: presentedDates },
          });
        }
      }
    }
  }

  setIsLoading(isLoading: boolean) {
    this.dispatch({
      type: ActionType.setIsLoading,
      payload: { isLoading: isLoading },
    });
  }

  setResult(result: Result) {
    result.subResults = this.state.result.subResults.concat(result.subResults); // add new appointments to collection
    result = AppointmentHelper.removeSubresultsDuplicates(
      result,
      this.state.selectedRegionCode,
      this.state.selectedSpecialisationCode
    ); // remove duplicates appointments
    const firstPossibleDateIndex = AppointmentHelper.getFirstSelectedIndex(
      result,
      this.state.allDays,
      this.state.currentPresentedDateIndex
    );
    const selectedDate = this.state.allDays[firstPossibleDateIndex]; // first possible date is selected by default
    this.dispatch({ type: ActionType.setResult, payload: { result: result } });

    this.setPresentedDates(result);
    this.setFirstPossibleDateIndex(firstPossibleDateIndex);
    this.setSelectedDate(selectedDate, true, firstPossibleDateIndex);
  }

  setPresentedDates(result: Result) {
    const presentedDates = AppointmentHelper.getPresentedDates(
      result,
      this.state.startPresentedDateIndex,
      this.state.stopPresentedDateIndex
    );
    this.dispatch({
      type: ActionType.setPresentedDates,
      payload: { presentedDates: presentedDates },
    });
  }
  setFirstPossibleDateIndex(firstPossibleDateIndex: number) {
    this.dispatch({
      type: ActionType.setCurrentPresentedDateIndex,
      payload: { currentPresentedDateIndex: firstPossibleDateIndex },
    });
  }

  setSelectedDate(
    date: Date,
    initialDate: boolean,
    firstPossibleDateIndex?: number
  ) {
    if (initialDate) {
      const selectedDate = this.state.allDays[firstPossibleDateIndex]; // first possible date is selected by default
      this.dispatch({
        type: ActionType.setSelectedDate,
        payload: { selectedDate: selectedDate },
      });
    } else {
      const newRequest = GetRequest(
        this.state.slotInterval,
        date,
        this.state.lastPossibleDate,
        this.state.selectedRegionCode,
        this.state.selectedSpecialisationCode,
        this.state.selectedClinicCode
      );
      const newIndex = AppointmentHelper.getSelectedIndex(
        this.state.allDays,
        date
      );

      this.dispatch({
        type: ActionType.setRequest,
        payload: { request: newRequest },
      }); // next appointment request onClick
      this.dispatch({
        type: ActionType.setCurrentPresentedDateIndex,
        payload: { currentPresentedDateIndex: newIndex },
      });
      this.dispatch({
        type: ActionType.setSelectedDate,
        payload: { selectedDate: date },
      });
    }
  }

  setNewPresentedDates(dateChange: -1 | 1) {
    if (dateChange === -1) {
      if(this.state.currentPresentedDateIndex != 0) {
        this.dispatch({
          type: ActionType.setPresentedDates,
          payload: { presentedDates: this.state.availableDays[(this.state.currentPresentedDateIndex - 1)] },
        });
        this.dispatch({
          type: ActionType.setCurrentPresentedDateIndex,
          payload: { currentPresentedDateIndex: (this.state.currentPresentedDateIndex - 1) },
        });
      }
      // if (!DateHelper.areDatesEqual(new Date(), this.state.presentedDates[0])) {
      //   const presentedDates = AppointmentHelper.getPresentedDates(
      //     this.state.result,
      //     this.state.startPresentedDateIndex - 1,
      //     this.state.stopPresentedDateIndex - 1
      //   );
        // this.dispatch({
        //   type: ActionType.setStartPresentedDateIndex,
        //   payload: {
        //     startPresentedDateIndex: this.state.startPresentedDateIndex - 1,
        //   },
        // });
        // this.dispatch({
        //   type: ActionType.setStopPresentedDateIndex,
        //   payload: {
        //     stopPresentedDateIndex: this.state.stopPresentedDateIndex - 1,
        //   },
        // });
        // this.dispatch({
        //   type: ActionType.setPresentedDates,
        //   payload: { presentedDates: presentedDates },
        // });
      //}
    } else if (dateChange === 1) {
      if((this.state.currentPresentedDateIndex + 1) < this.state.availableDays.length) {
        this.dispatch({
          type: ActionType.setPresentedDates,
          payload: { presentedDates: this.state.availableDays[(this.state.currentPresentedDateIndex + 1)] },
        });
        this.dispatch({
          type: ActionType.setCurrentPresentedDateIndex,
          payload: { currentPresentedDateIndex: (this.state.currentPresentedDateIndex + 1) },
        });
      }
      // const presentedDates = AppointmentHelper.getPresentedDates(
      //   this.state.result,
      //   this.state.startPresentedDateIndex + 1,
      //   this.state.stopPresentedDateIndex + 1
      // );
      // const lastPresentedDate =
      //   this.state.presentedDates[this.state.presentedDates.length - 1];
      // const lastResultDate =
      //   this.state.result.subResults[this.state.result.subResults.length - 1]
      //     .appointmentsDate;

      // if (lastPresentedDate.getTime() < lastResultDate.getTime()) {
      //   this.dispatch({
      //     type: ActionType.setStartPresentedDateIndex,
      //     payload: {
      //       startPresentedDateIndex: this.state.startPresentedDateIndex + 1,
      //     },
      //   });
      //   this.dispatch({
      //     type: ActionType.setStopPresentedDateIndex,
      //     payload: {
      //       stopPresentedDateIndex: this.state.stopPresentedDateIndex + 1,
      //     },
      //   });
      //   this.dispatch({
      //     type: ActionType.setPresentedDates,
      //     payload: { presentedDates: presentedDates },
      //   });
      // }

      // if (DateHelper.areDatesEqual(lastPresentedDate, lastResultDate)) {
      //   const newAppDate = DateHelper.addDays(lastPresentedDate, 1);
      //   const newRequest = GetRequest(
      //     this.state.slotInterval,
      //     newAppDate,
      //     this.state.lastPossibleDate,
      //     this.state.selectedRegionCode,
      //     this.state.selectedSpecialisationCode,
      //     this.state.selectedClinicCode
      //   );
      //   this.dispatch({
      //     type: ActionType.setRequest,
      //     payload: { request: newRequest },
      //   });
      // }
    }
  }

  onTimeSelect(event) {
    const selectedTimeInterval = event.target.value;
    const newRequest = GetRequest(
      Number(selectedTimeInterval),
      this.state.presentedDates[0],
      this.state.lastPossibleDate,
      this.state.selectedRegionCode,
      this.state.selectedSpecialisationCode,
      this.state.selectedClinicCode
    );

    this.dispatch({
      type: ActionType.setSelectedTimeInterval,
      payload: { slotInterval: selectedTimeInterval },
    });
    this.dispatch({
      type: ActionType.setRequest,
      payload: { request: newRequest },
    });
  }

  onClinicSelect(event) {
    const selectedClinicCode = event.target.value;
    const newRequest = GetRequest(
      Number(this.state.slotInterval),
      this.state.presentedDates[0],
      this.state.lastPossibleDate,
      this.state.selectedRegionCode,
      this.state.selectedSpecialisationCode,
      selectedClinicCode
    );

    this.dispatch({
      type: ActionType.setClinicCode,
      payload: { selectedClinicCode: selectedClinicCode },
    });
    this.dispatch({
      type: ActionType.setRequest,
      payload: { request: newRequest },
    });
  }
}
export default MegawidgetCommonFacade;
